import { render, staticRenderFns } from "./AppToolsFindPosSale.vue?vue&type=template&id=45546bb0"
import script from "./AppToolsFindPosSale.vue?vue&type=script&lang=ts"
export * from "./AppToolsFindPosSale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports